
































import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";

export interface JobsearchRecruiteeSearchParams {
  ibow_user_id?: string;
  ibow_system_id?: string;
  jst_no?: string;
  recruitee_name?: string;
  ibow_email?: string;
  email?: string;
}

@Component({
  components: {
    AppTextField,
  },
})
export default class extends Vue {
  private ibow_user_id = "";
  private ibow_system_id = "";
  private jst_no = "";
  private recruitee_name = "";
  private ibow_email = "";
  private email = "";

  @Emit()
  private search(): JobsearchRecruiteeSearchParams {
    const params: JobsearchRecruiteeSearchParams = {
      ibow_user_id: this.ibow_user_id,
      ibow_system_id: this.ibow_system_id,
      jst_no: this.jst_no,
      recruitee_name: this.recruitee_name,
      ibow_email: this.ibow_email,
      email: this.email,
    };
    return params;
  }
}
